module.exports = __webpack_public_path__ + "static/react-router-logo.90bf4f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/react-router-logo.png
// module id = 2546
// module chunks = 35783957827783